import { render, staticRenderFns } from "./Fileupload.vue?vue&type=template&id=364a6e35&scoped=true"
import script from "./Fileupload.vue?vue&type=script&lang=js"
export * from "./Fileupload.vue?vue&type=script&lang=js"
import style0 from "./Fileupload.vue?vue&type=style&index=0&id=364a6e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a6e35",
  null
  
)

export default component.exports